// Region-aware checkout. PH visitors hit PayMongo (₱199, GCash/Maya/QRPh).
// Everyone else gets routed to Polar's hosted checkout in USD ($5.59).
//
// We intentionally don't gate the PH path by IP — GCash itself is the moat
// (registration requires a PH SIM, so a foreign visitor who finds the PH
// link can't actually pay through it). Detection just chooses the better
// default for the visitor's region.

const POLAR_CHECKOUT_URL = import.meta.env.VITE_POLAR_CHECKOUT_URL || ""

export async function getRegion() {
  try {
    const resp = await fetch("/api/region", { cache: "no-store" })
    if (!resp.ok) return { country: null, is_ph: false }
    return await resp.json()
  } catch {
    return { country: null, is_ph: false }
  }
}

export async function startPhCheckout({ email }) {
  // Email is mandatory: QRPh and some GCash flows skip PayMongo's email
  // collection, so without an upfront email the buyer never gets their
  // license key. The backend validates the format too.
  const resp = await fetch("/api/paymongo/checkout", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  })

  let data
  try { data = await resp.json() } catch { data = null }

  if (!resp.ok || !data?.checkout_url) {
    // Special case: typo with a concrete fix. Surface the suggestion so the
    // UI can offer one-click correction instead of a dead-end error.
    if (data?.error === "email_typo" && data?.suggestion) {
      const err = new Error(`Did you mean @${data.suggestion}?`)
      err.code = "email_typo"
      err.suggestion = data.suggestion
      err.status = resp.status
      throw err
    }
    // Map a few backend codes to friendlier sentences. The rest fall
    // through with the raw error code so we can grep them in logs.
    const friendly = {
      invalid_email: "That email doesn't look right. Double-check the spelling.",
      invalid_email_domain: "We can't deliver mail to that domain. Did you mean a different one?",
      ph_only: "PH pricing is for buyers in the Philippines. Use the global option instead.",
      rate_limited: "Too many attempts. Wait a minute and try again.",
    }[data?.error]
    const err = new Error(friendly || data?.error || `Checkout failed (${resp.status})`)
    err.code = data?.error
    err.status = resp.status
    throw err
  }

  window.location.href = data.checkout_url
}

export function startGlobalCheckout() {
  if (!POLAR_CHECKOUT_URL) {
    throw new Error("Polar checkout URL not configured")
  }
  window.location.href = POLAR_CHECKOUT_URL
}
